module.exports = __webpack_public_path__ + "img/nebraska-walgreens.94bcbf36.png";